import { myAxios } from "../../utils/serverContextPath";

export const getSpecialiteById = (id) => {
  return myAxios.get(`specialite/getbyid/${id}`);
};

export const getSpecialiteAllPage = (
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("specialite/getallpage", {
    params: {
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const getAllSpecialite = (
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("specialite/getall", {
    params: {
      keyword,
      sortList,
      sortOrder,
    },
  });
};

export const getByNatureActivityTypeKeyWord = (
  val = "",
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("specialite/getbynatureactivitytypekeyword", {
    params: {
      val,
      keyword,
      sortList,
      sortOrder,
    },
  });
};


export const getByNatureActivityTypeKeyWordPage = (
  val = "",
  keyword = "",
  pageNumber = 0,
  itemsPerPage = 10,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("specialite/getbynatureactivitytypekeywordpage", {
    params: {
      val,
      keyword,
      page: pageNumber,
      size: itemsPerPage,
      sortList,
      sortOrder,
    },
  });
};

export const deleteSpecialite = (id) => {
  return myAxios.delete(`specialite/delete/${id}`);
};

export const postSpecialite = (data) => {
  return myAxios.post("specialite/save/insert", data);
};

export const updateSpecialite = (data) => {
  return myAxios.post("specialite/save/Update", data);
};

export const findSimilarSpecialite = (
  keyword,
  tauxsimilarity = 0.8,
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("specialite/similarity", {
    params: {
      keyword,
      tauxsimilarity,
      sortList,
      sortOrder,
    },
  });
};

export const getSpecialiteByNatureActivityType = (
  val = "",
  keyword = "",
  sortList = [],
  sortOrder = "DESC"
) => {
  return myAxios.get("specialite/getbynatureactivitytype", {
    params: {
      val,
      keyword,
      sortList,
      sortOrder,
    },
  });
};
